import { orgSelectors } from 'ducks/orgs'
import { isEmpty } from 'lodash'
import { DistributorConnectionStatusesType, HardwareSupplierFilterKeyType } from 'pages/ordering/type'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

// similar to useDistributorsAuthenticationStatus, but using Redux state instead of API calls
const useDistributorsAuthenticationStatus = ({
  orgId,
  distributors,
}: {
  orgId: number
  distributors: HardwareSupplierFilterKeyType[]
}) => {
  const [distributorsAuthenticationStatus, setDistributorsAuthenticationStatus] =
    useState<DistributorConnectionStatusesType>({})

  // Get seller integrations from Redux state
  const sellerIntegrations = useSelector(orgSelectors.getOrgSellerIntegrations)

  useEffect(() => {
    const populateData = () => {
      const statusData: DistributorConnectionStatusesType = {}

      // Handle Outlet - always authenticated
      if (distributors.includes('outlet')) {
        statusData['outlet'] = { isAuthenticated: true }
      }

      // Handle all other distributors from Redux state
      distributors.forEach((distributor) => {
        if (!['outlet'].includes(distributor)) {
          const integration = sellerIntegrations?.find((integration) => integration.filterKey === distributor)
          statusData[distributor] = {
            isAuthenticated: integration?.isEnabled ?? false,
          }
        }
      })

      setDistributorsAuthenticationStatus(statusData)
    }

    if (!isEmpty(distributors)) {
      populateData()
    }
  }, [distributors.toString(), sellerIntegrations])

  return distributorsAuthenticationStatus
}

export default useDistributorsAuthenticationStatus
